import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { defineMessages, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { ConfluenceLogo } from '@atlaskit/logo';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { LoginToConfluenceIcon } from './LoginPageIconSVG';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import RefreshBanner from './RefreshBanner';
var SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
var StyledParentDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   {\n    display: inline-grid;\n    align-items: center;\n    justify-items: center;\n    margin-top: ", ";\n  }\n"])), "var(--ds-space-1000, 80px)");
var StyledConfluenceIcon = styled(LoginToConfluenceIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), "var(--ds-space-250, 20px)");
var StyledConfluenceLoginText = styled.h2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   {\n    margin-top: ", ";\n  }\n"])), "var(--ds-space-250, 20px)");

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
var StyledLoginButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  && {\n    margin-top: 30px;\n  }\n"])));
var fadeIn = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var messages = defineMessages({
  loginAriaLabel: {
    id: 'embedded.confluence.login-page.login-button.aria-label',
    description: 'The aria label for login button',
    defaultMessage: 'Login Button'
  },
  loginText: {
    id: 'embedded.confluence.login-page.login-text',
    description: 'Text to display before login button',
    defaultMessage: 'You need to be logged in to view this page'
  },
  loginButton: {
    id: 'embedded.confluence.login-page.login-button',
    description: 'The label for login button',
    defaultMessage: 'Log in to Confluence'
  }
});
export var LoginPage = function LoginPage(_ref) {
  var contentId = _ref.contentId,
    formattedLocale = _ref.formattedLocale,
    reloadEP = _ref.reloadEP,
    spaceKey = _ref.spaceKey,
    url = _ref.url;
  var loginUrl = React.useMemo(function () {
    var _window, _window$location;
    var origin = url ? new URL(url).origin : (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin;
    return "".concat(origin, "/login?application=confluence&dest-url=").concat(encodeURIComponent("".concat(SUCCESS_URL_SUFFIX, "?locale=").concat(formattedLocale)));
  }, [url, formattedLocale]);
  var handleClick = function handleClick() {
    openLoginPopup(loginUrl);
    setDisplayRefreshBanner(!displayRefreshBanner);
  };
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayRefreshBanner = _useState2[0],
    setDisplayRefreshBanner = _useState2[1];
  var RefreshBannerFade = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: ", ";\n    animation: ", " 3s;\n  "])), "var(--ds-space-250, 20px)", fadeIn);
  return /*#__PURE__*/React.createElement(StyledParentDiv, null, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.LOGIN_PAGE,
    id: "".concat(spaceKey, "-").concat(contentId)
  }), /*#__PURE__*/React.createElement(ConfluenceLogo, {
    size: "large",
    appearance: "brand"
  }), /*#__PURE__*/React.createElement(StyledConfluenceIcon, null), /*#__PURE__*/React.createElement(StyledConfluenceLoginText, null, formatMessage(messages.loginText)), /*#__PURE__*/React.createElement(StyledLoginButton, {
    testId: "login-button",
    "aria-label": formatMessage(messages.loginAriaLabel),
    appearance: "primary",
    onClick: handleClick
  }, formatMessage(messages.loginButton)), displayRefreshBanner && /*#__PURE__*/React.createElement(RefreshBannerFade, null, /*#__PURE__*/React.createElement(RefreshBanner, {
    reloadEP: reloadEP
  })));
};
function openLoginPopup(loginUrl) {
  var windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
  window.open(loginUrl, '_blank', windowFeatures);

  //TO-DO - Add Analytics
}